import { StrokeProps } from 'react-native-svg';

import HeartIcon from '%assets/icons/heart-like.svg';
import { colors } from '%theme';

const defaultColor = colors.primary;
const activeColor = colors.accent;

export const Heart = ({ active, strokeColor }: Props) => {
	if (active) {
		return <HeartIcon fill={activeColor} stroke={activeColor} />;
	}

	return <HeartIcon stroke={strokeColor || defaultColor} />;
};

type Props = {
	active: boolean;
	strokeColor?: StrokeProps['stroke'];
};
